import {
    GivelifyBreadcrumbs,
    GivelifyButton,
    GivelifyLabel,
    GivelifyPaper,
} from '@givelify/ui';
import { Divider, styled } from '@mui/material';

export const Container = styled(GivelifyPaper)(({ theme }) => ({
    padding: theme.spacing(4),
    [theme.breakpoints.down('mobile')]: {
        padding: theme.spacing(2),
    },
}));

export const SectionDivider = styled(Divider)(({ theme }) => ({
    margin: theme.spacing(3, 0),
}));

export const PreviewLeft = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
}));

export const PreviewContent = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
}));

export const PreviewRight = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
}));

export const CodeBlock = styled('div')({
    background: '#F4F4F4',
    borderRadius: '4px',
    padding: '16px 20px',
    textAlign: 'center',
    wordBreak: 'break-word',
    maxWidth: '512px',
});

export const CopyCodeButton = styled(GivelifyButton)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        maxWidth: 140,
        margin: '8px auto 0 auto',
    },
}));

export const Breadcrumbs = styled(GivelifyBreadcrumbs)(({ theme }) => ({
    '& .separator': {
        margin: theme.spacing(0, 1),
    },
    marginBottom: theme.spacing(3),
}));

export const PublicHeading = styled(GivelifyLabel)(() => ({
    margin: '127px 0 31px 0',
}));

export const PublicContainer = styled('div')(() => ({
    display: 'flex',
    width: '100%',
    flexGrow: 1,
    maxWidth: '1040px',
    flexDirection: 'column',
    margin: '0 auto',
    paddingBottom: '80px',
}));
